import { render, staticRenderFns } from "./page-notice.vue?vue&type=template&id=937b95d2&scoped=true"
import script from "./page-notice.vue?vue&type=script&lang=js"
export * from "./page-notice.vue?vue&type=script&lang=js"
import style0 from "./page-notice.vue?vue&type=style&index=0&id=937b95d2&prod&scoped=true&lang=scss"
import style1 from "./page-notice.vue?vue&type=style&index=1&id=937b95d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937b95d2",
  null
  
)

export default component.exports